import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { alertaGeneral } from "../../utils/alertas";
import apiClient from "../../utils/axiosPetition";

const PagRespuestaCursoPayU = () => {
    const [searchParams] = useSearchParams();
    const [transactionState] = searchParams.get('transactionState');
    const referenceCode = searchParams.get('reference_pol');
    const [isApproved, setIsApproved] = useState(false);
    const { cursoId } = useParams();
    const navigate = useNavigate();

    const onApproved = () => {
        console.log('Transacción aprobada');
        const doctorId = localStorage.getItem('doctorId');
        const dataToSend = {
            doctorId,
            referenceCode
        }

        apiClient.post(`/api/cursos/registrarPagoCurso/${cursoId}`, dataToSend)
            .then(res => {
                navigate("/doctor");
            })
            .catch(error => {
                alertaGeneral({
                    titulo: 'Error',
                    messageHtml: error.response?.data?.message || 'Ocurrió un error al registrar el pago del curso',
                    isError: true
                });
                navigate("/doctor");
            });
    };

    useEffect(() => {
        if (transactionState === "4" && !isApproved) {
            alertaGeneral({
                titulo: 'Transacción aprobada',
                messageHtml: 'Su inscripción al curso ha sido exitosa',
            });
            onApproved();
            setIsApproved(true);
        } else if (transactionState !== "4") {
            alertaGeneral({
                titulo: 'Error',
                messageHtml: 'La transacción no fue aprobada',
                isError: true
            });
        }
    }, [transactionState, isApproved]);
}

export default PagRespuestaCursoPayU;